/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Pbincja3Inputs */

const ja_company_companydetails_pbincja3 = /** @type {(inputs: Company_Companydetails_Pbincja3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(株式会社プレイブレーン)`)
};

const en_company_companydetails_pbincja3 = /** @type {(inputs: Company_Companydetails_Pbincja3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(株式会社プレイブレーン)`)
};

/**
* | output |
* | --- |
* | "(株式会社プレイブレーン)" |
*
* @param {Company_Companydetails_Pbincja3Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_pbincja3 = /** @type {((inputs?: Company_Companydetails_Pbincja3Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Pbincja3Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_pbincja3(inputs)
	return en_company_companydetails_pbincja3(inputs)
});
export { company_companydetails_pbincja3 as "company_companyDetails_pbIncJa" }